import React from 'react';

import { PK, SelectOption } from 'common/types';
import { STATUSES } from 'common/consts';
import { RelationOption } from 'common/components/RelationSelect';

import { useCollectionItemsUpdate } from './queries';

import { useMemo } from 'react';
import { MinimalContent } from '../../base/api/types';

export const useContentItems = (
  collectionItems: PK[],
  contentList: MinimalContent[],
): SelectOption<PK>[] => {
  return useMemo(() => {
    const contentMap = new Map(contentList.map((item) => [item.pk, item]));

    return collectionItems.reduce<SelectOption<PK>[]>((acc, collectionItem) => {
      const fullData = contentMap.get(collectionItem);

      if (fullData) {
        acc.push({
          value: fullData.pk,
          label: fullData.title,
        });
      }

      return acc;
    }, []);
  }, [collectionItems, contentList]);
};

interface ReorderContentArguments {
  items: RelationOption[];
}

export const useUpdateContentItems = (pk?: PK) => {
  const {
    mutate: updateContentItems,
    isSuccess: isUpdateSuccess,
    isLoading: isUpdateLoading,
    isError: isUpdateError,
    error,
  } = useCollectionItemsUpdate();

  const handleUpdate = ({ items }: ReorderContentArguments) => {
    if (pk) {
      const payload = {
        collectionPk: pk,
        items_pks: items.map((item) => item.value),
      };

      updateContentItems(payload);
    }
  };

  return {
    save: handleUpdate,
    isSuccess: isUpdateSuccess,
    isLoading: isUpdateLoading,
    isError: isUpdateError,
    error: error,
  };
};

interface ActiveFilterArguments {
  status: STATUSES;
}

export const useActiveFilter = (initiallyEnabled = false) => {
  const [filterEnabled, setFilterEnabled] = React.useState(initiallyEnabled);
  const toggleActiveFilter = () => setFilterEnabled((filterEnabled) => !filterEnabled);
  const activeFilter = ({ status }: ActiveFilterArguments) =>
    !filterEnabled || status === STATUSES.ACTIVE;

  return {
    filterEnabled,
    toggleActiveFilter,
    activeFilter,
  };
};
